import React from 'react';
import _ from 'lodash';
import Page from './Page';
import ShortForm from './ShortForm';
import Select from './Select';
import TextField from 'material-ui/TextField';
import ArrowUp from 'material-ui-icons/ArrowUpward';
import ArrowDown from 'material-ui-icons/ArrowDownward';
import SearchIcon from 'material-ui-icons/Search';
import ExperimentListItem from './ExperimentListItem';

const SORT_COLUMN_OPTIONS = [
	{ value:"name",     label: "Name"},
	{ value:"start", label: "Start Date"},
	{ value:"time",      label: "Estimated Time"},
	{ value:"incentive", label: "Reward"},
];


export default class Experiments extends Page {

	static get mustBeParticipant(){ return true; }

	constructor(...args){
		super(...args);
		this.app.viewExperimentsForm.loading = true;
	}

	componentDidMount(){
		this.app.viewExperimentsForm.load();
	}

	render(){

		let rows = window.app.viewExperimentsForm.rows || [];

		rows = this.app.fuzzyMatch(rows, this.app.viewExperimentsForm.search, row => row.name )
		rows = _.sortBy(rows, this.app.viewExperimentsForm.sortColumn || 'name')
		if(!this.app.viewExperimentsForm.sortAscending){
			rows.reverse();
		}

		return (
			<ShortForm 
				label="Experiments"
				formWidth="small"
				waiting={this.app.viewExperimentsForm.loading}
			>

				<div className="hint" style={{margin:'0 0 20px 0'}}>TIP: By completing more of your profile, you may be eligible to participate in more experiments.</div>

				<div className='Experiments-filters'>
					<TextField
						label={<SearchIcon />}
						id="search"
						value={window.app.viewExperimentsForm.search || ''}
						onChange={ e => {window.app.viewExperimentsForm.search = e.currentTarget.value; window.app.forceUpdate()} }
						margin="normal"
						autoComplete="off"
						style={{width:'120px'}}
						/>
					&nbsp;&nbsp;
					<Select
						label="Sort by"
						id="sortColumn"
						value={window.app.viewExperimentsForm.sortColumn}
						onChange={ o =>{ window.app.viewExperimentsForm.sortColumn = o.value; window.app.forceUpdate(); } }
						options={SORT_COLUMN_OPTIONS}
						/>

					<div 
						onClick={  o =>{ window.app.viewExperimentsForm.sortAscending = !window.app.viewExperimentsForm.sortAscending; window.app.forceUpdate(); } }
						style={{display:'inline-block', position: 'relative',top: '7px', paddingLeft: '7px'}}>
						{ !!window.app.viewExperimentsForm.sortAscending ? <ArrowUp /> : <ArrowDown /> }
					</div>
				</div>
				
				{rows.map( (row, i) => (
					<ExperimentListItem row={row} key={i} participantMode />
				))}

				{ rows.length === 0 && 
				<div>
					There are no experiments available.
				</div>
				}


			</ShortForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Experiments.js